/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */
import { routerReducer } from 'react-router-redux';

// use this import if you need to combine multiple reducers under the same key.
import authorizationReducer from './containers/Authorization/reducer';
import searchBarReducer from './containers/SearchBar/reducer';
import notificationsReducer from './containers/Notifications/reducer';
import languageProviderReducer from './providers/LanguageProvider/reducer';
import googleCalendarReducer from './containers/GoogleCalendar/reducer';
import persistedCollegeProfile from './containers/CollegeProfileReact/persistedReducers';
import nonPersistedCollegeProfile from './containers/CollegeProfileReact/nonPersistedReducers';
import cmsData from './containers/CollegeProfileReact/reducer';

const reducers = {
  current: authorizationReducer,
  language: languageProviderReducer,
  notifications: notificationsReducer,
  globalSearch: searchBarReducer,
  routing: routerReducer,
  googleCalendar: googleCalendarReducer,
  persistedCollegeProfile,
  nonPersistedCollegeProfile,
  cmsData,
};

export const REDUCER_NAME_BASIC_INFO = 'basicInfo';
export default reducers;
